import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Button, ButtonGroup, Col, Container, FloatingLabel, Form, Image, Row, Tab, Tabs, ToggleButton } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoginInfo } from '../App.js';
import Birthday from '../domain/Birthday.ts';
import Email from '../domain/Email.js';
import HomePage from '../domain/HomePage.js';
import InstagramId from '../domain/InstagramId.js';
import Password from '../domain/Password.js';
import ProfileImage from '../domain/ProfileImage.js';
import SelfIntroduction from '../domain/SelfIntroduction.js';
import Sex from '../domain/Sex.js';
import TwitterId from '../domain/TwitterId.js';
import UserId from '../domain/UserId.js';
import UserInfo from '../domain/UserInfo.ts';
import AiWorksDisplayFlag from '../domain/R18DisplayFlag.js'
import UserName from '../domain/UserName.js';
import * as ImageUtil from '../service/ImageUtil.js';
import ApiFetch from './ApiFetch.js';
import Dialog from './Dialog.js';
import Footer from './Footer.js';
import Header from './Header.js';
import OnetimePassword from '../domain/OnetimePassword.js';
import CampaignMessage from './CampaignMessage.js';
import Category from './Category.js';
import R18DisplayFlag from '../domain/R18DisplayFlag.js';
import R18GDisplayFlag from '../domain/R18GDisplayFlag.js';
import DisplayId from '../domain/DisplayId.js';
import GitHubId from '../domain/GitHubId.js';
import HuggingFaceId from '../domain/HuggingFaceId.js';
import { useTranslation } from "react-i18next";
import { isLoggin } from '../service/LoginService.js';
import SexualExpressionDisplayFlag from '../domain/PG12DisplayFlag.js';
import Language from '../domain/Language.js';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import Thumb from './common/Thumb.js';
import RankingRecordImage from './RankingRecordImage.js';
import { Link } from 'react-router-dom';

const RankingRecordPopup = (props) => {
    async function getUserInfo(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/my")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getUserSetting(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userSetting/my")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getRankingTrackRecord(userId,styleOfPainting,genre,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/rankingRecord/"+userId+"/"+styleOfPainting+"/"+genre+"/"+page)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    // ナビゲート
    const navigate = useNavigate();

    const [oneTimePasswordSended, setOneTimePasswordSended] = useState(false);
    const [profileImage, setProfileImage] = useState("");

    // 投稿遅延ロード
    const options = {
        root: null,
        rootMargin: "1000px",
        threshold: 0.05
    }
    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                //imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.dataset.type === "allAges" && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (pageAllAges * 30 - 1) ){
                    setPageAllAges(pageAllAges+1)
                }
                if(imgEl.dataset.type === "pg12" && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (pagePG12 * 30 - 1) ){
                    setPagePG12(pagePG12+1)
                }
                if(imgEl.dataset.type === "r15" && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (pageR15 * 30 - 1) ){
                    setPageR15(pageR15+1)
                }
                if(imgEl.dataset.type === "r18" && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (pageR18 * 30 - 1) ){
                    setPageR18(pageR18+1)
                }
                if(imgEl.dataset.type === "all" && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (pageAll * 30 - 1) ){
                    setPageAll(pageAll+1)
                }
            }
        })
    }, options);

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    // フラグ：AI生成作品を表示する
    const [pg12Value, setPG12Value] = useState('2');// 性的表現(軽微)
    const [r15Value, setR15Value] = useState('2');
    const [r18Value, setR18Value] = useState('2');
    const [r18GValue, setR18GValue] = useState('2');
    const [userInfo, setUserInfo] = useState([]);
    const [userSetting, setUserSetting] = useState([]);
    const [sex, setSex] = useState(1);
    const [language, setLanguage] = useState(1);
    const [pageAllAges, setPageAllAges] = useState(1);
    const [pagePG12, setPagePG12] = useState(1);
    const [pageR15, setPageR15] = useState(1);
    const [pageR18, setPageR18] = useState(1);
    const [pageAll, setPageAll] = useState(1);
    const [rankingRecordListAllAges, setRankingRecordListAllAges] = useState([]);
    const [rankingRecordListPG12, setRankingRecordListPG12] = useState([]);
    const [rankingRecordListR15, setRankingRecordListR15] = useState([]);
    const [rankingRecordListR18, setRankingRecordListR18] = useState([]);
    const [rankingRecordListAll, setRankingRecordListAll] = useState([]);
    const [styleOfPainting,setStyleOfPainting] = useState("illustration")

    // 初期処理
    useEffect(() => {
        // タイトル設定
        //document.querySelector("title").textContent = t("rankingRecord.title") + " - アワートAI"
        getUserInfo().then(r=>{
            setUserInfo(r)
            setSex(r.sex)
        })
        getUserSetting().then(r=>{
            setUserSetting(r)
            setPG12Value(String(r.data.pg12_display_flag))
            setR15Value(String(r.data.r15_display_flag))
            setR18Value(String(r.data.r18_display_flag))
            setR18GValue(String(r.data.r18g_display_flag))
            setLanguage(String(r.data.language))
        })
        // 全年齢
        getRankingTrackRecord(props.userId,styleOfPainting,"general",1).then(r => {
            if(r.result){
                setRankingRecordListAllAges(r.data)
            }
        })
        // PG12
        getRankingTrackRecord(props.userId,styleOfPainting,"pg12",1).then(r => {
            if(r.result){
                setRankingRecordListPG12(r.data)
            }
        })
        // R15
        getRankingTrackRecord(props.userId,styleOfPainting,"r15",1).then(r => {
            if(r.result){
                setRankingRecordListR15(r.data)
            }
        })
        // R18
        getRankingTrackRecord(props.userId,styleOfPainting,"r18",1).then(r => {
            if(r.result){
                setRankingRecordListR18(r.data)
            }
        })
        // 総合
        getRankingTrackRecord(props.userId,styleOfPainting,"all",1).then(r => {
            if(r.result){
                setRankingRecordListAll(r.data)
            }
        })
    },[styleOfPainting])

    document.onkeydown = (e) => {
        if(e.key === "Escape" || e.key === "Backspace"){
            props.switch(false)
        }
    }
    return (
        <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",backgroundColor:"#000000",zIndex:4}}>
        <div id="setting-popup" style={{position:"fixed",top:"1%",left:"1%",width:"98%",height:"98%",zIndex:5,overflow:"auto",backgroundColor:"#FFFFFF",borderRadius:"20px"}}>
        <Button variant='secondary' className='m-3' style={{position:"fixed",left:"14px",zIndex:1}} onClick={() => props.switch(false)}>{t("common.close")}</Button>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Container className='d-flex flex-row justify-content-center flex-wrap' style={{marginTop:"60px"}}>
            <h3>{t("rankingRecord.title")}</h3><br />
            <Container className='text-center'>
                <Button onClick={() => setStyleOfPainting("illustration")} variant={(styleOfPainting === "illustration" ? "" : "outline-") + 'secondary'}>{t("common.illustration")}</Button>
                &nbsp;
                <Button  onClick={() => setStyleOfPainting("semirealism")} variant={(styleOfPainting === "semirealism" ? "" : "outline-") + 'secondary'}>{t("common.semirealism")}</Button>
                &nbsp;
                <Button  onClick={() => setStyleOfPainting("photorealistic")} variant={(styleOfPainting === "photorealistic" ? "" : "outline-") + 'secondary'}>{t("common.photorealistic")}</Button>
            </Container>
            <Tabs defaultActiveKey="allAges" id="uncontrolled-tab-example" className="mt-3 mb-3 w-100" style={{}}>
                <Tab eventKey="allAges" title={<>{t("common.allAges")}</>} className='w-100'>
                    <Container className={'d-flex flex-row justify-content-start flex-wrap w-100'}>
                        {rankingRecordListAllAges.map((data,i) => {
                            return <RankingRecordImage dataType="allAges" key={i} data={data} dialog={dialog} observer={observer} />
                        })}
                    </Container>
                </Tab>
                <Tab eventKey="pg12" title={<>PG12</>} className='w-100'>
                    <Container className={'d-flex flex-row justify-content-start flex-wrap w-100'}>
                        {rankingRecordListPG12.map((data,i) => {
                            return <RankingRecordImage dataType="r15" key={i} data={data} dialog={dialog} observer={observer} />
                        })}
                    </Container>
                </Tab>
                <Tab eventKey="r15" title={<>R15</>} className='w-100'>
                    <Container className={'d-flex flex-row justify-content-start flex-wrap w-100'}>
                        {rankingRecordListR15.map((data,i) => {
                            return <RankingRecordImage dataType="r15" key={i} data={data} dialog={dialog} observer={observer} />
                        })}
                    </Container>
                </Tab>
                <Tab eventKey="r18" title={<>R18</>} className='w-100'>
                    <Container className={'d-flex flex-row justify-content-start flex-wrap w-100'}>
                        {rankingRecordListR18.map((data,i) => {
                            return <RankingRecordImage dataType="r18" key={i} data={data} dialog={dialog} observer={observer} />
                        })}
                    </Container>
                </Tab>
                <Tab eventKey="all" title={<>{t("common.all")}</>} className='w-100'>
                    <Container className={'d-flex flex-row justify-content-start flex-wrap w-100'}>
                        {rankingRecordListAll.map((data,i) => {
                            return <RankingRecordImage dataType="all" key={i} data={data} dialog={dialog} observer={observer} />
                        })}
                    </Container>
                </Tab>
            </Tabs>
        </Container>
        </div>
        </div>
    )
}

export default RankingRecordPopup;
